var ils;
(function (ils) {
    let ApartmentMaps;
    (function (ApartmentMaps) {
        var geocoder;
        var map;
        var neighborhoodMap;
        var markers = [];
        var bounds;
        var infoBox;
        function initializeMap() {
            if (globalThis.loaded)
                return;
            try {
                bounds = new google.maps.LatLngBounds();
                geocoder = new google.maps.Geocoder();
                map = new google.maps.Map(document.getElementById("map_canvas"));
                codeAddress(globalThis.residenceAddress, true);
                if (!(globalThis.officeAddress == null || globalThis.officeAddress == ''))
                    codeAddress(globalThis.officeAddress, false);
                globalThis.loaded = true;
                $.getScript(`https://apicdn.walkscore.com/api/v1/traveltime_widget/js?wsid=${globalThis.ws_wsid}`, function (data, textStatus, jqxhr) {
                    ApartmentMaps.travelTimeWidget = new walkscore.TravelTimeWidget({
                        map: map,
                        origin: `${globalThis.residenceLat},${globalThis.residenceLong}`,
                        show: false,
                        mode: walkscore.TravelTime.Mode.DRIVE
                    });
                });
                google.maps.event.addListener(map, "idle", function () {
                    $(".map-loading").hide();
                });
                ils.trackGoogleMapsEvent(ils.MapsGACategories.DynamicMaps, 'load', 'CDP Directions Map', 7);
                //ga('send', 'event', ils.MapsGACategories.DynamicMaps, 'load', 'CDP Directions Map', 7);
            }
            catch (e) {
                console.error(e);
            }
        }
        ApartmentMaps.initializeMap = initializeMap;
        function initializeStaticMap() {
            setMapsImage();
            function setMapsImage() {
                let location;
                if (ils.googleMapsLat && ils.googleMapsLat != 0 && ils.googleMapsLong && ils.googleMapsLong != 0) {
                    location = `${ils.googleMapsLat},${ils.googleMapsLong}`;
                }
                else {
                    location = globalThis.residenceAddress;
                }
                const encodedImage = encodeURIComponent(`${window.location.origin}/img/map-marker-62.png`);
                const markerImageParam = `icon:${encodedImage}|${location}`;
                const isMobile = globalThis.breakpoint() == 'mobile';
                // Create the map URL and the img tag
                const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?size=${(isMobile ? '375' : '425')}x${(isMobile ? '375' : '425')}&markers=${markerImageParam}&key=${ils.googleMapsKey}`;
                const imgDivParts = [
                    `<div style="width: ${(isMobile ? '100%' : '50%')}; margin: auto;">`,
                    `	<div id="static-directions-map" style="cursor: pointer; background-repeat: no-repeat;; background-image: url('${mapUrl}'); min-height: 375px;">&nbsp;</div>`,
                    '</div>'
                ];
                const imageDivElement = imgDivParts.join('');
                ils.viewModel.DirectionsMapContents(imageDivElement);
                ils.googleStaticCommunityMapLoaded = true;
                $(".map-loading").hide();
                ils.trackGoogleMapsEvent(ils.MapsGACategories.StaticMaps, 'load', 'CDP Directions Map', 2);
                //ga('send', 'event', ils.MapsGACategories.StaticMaps, 'load', 'CDP Directions Map', 2);
                var clickTimeout = setTimeout(() => {
                    $("#static-directions-map").on('click', () => {
                        ils.trackGoogleMapsEvent(ils.MapsGACategories.StaticMaps, 'click', 'CDP Directions Map', 2);
                        //ga('send', 'event', 'DirectionsMap', 'click', window.location.pathname);
                        loadDynamicDirectionsMap();
                    });
                    clearTimeout(clickTimeout);
                }, 150);
            }
        }
        ApartmentMaps.initializeStaticMap = initializeStaticMap;
        function loadDynamicDirectionsMap() {
            if (!ils.googleMapsApiLoaded || !google) {
                ils.loadApartmentMapScripts(() => {
                    const mapTimeout = setTimeout(() => {
                        loadDynamicMap();
                        clearTimeout(mapTimeout);
                    }, 100);
                });
            }
            else {
                loadDynamicMap();
            }
            function loadDynamicMap() {
                ils.viewModel.DirectionsMapContents('');
                $(".map-loading").show();
                initializeMap();
            }
        }
        ApartmentMaps.loadDynamicDirectionsMap = loadDynamicDirectionsMap;
        function loadDynamicNeighborhoodMap() {
            ils.loadApartmentMapScripts(() => {
                const mapTimeout = setTimeout(() => {
                    loadDynamicMapForNeighborhood();
                    clearTimeout(mapTimeout);
                }, 100);
            });
            function loadDynamicMapForNeighborhood() {
                ils.viewModel.NeighborhoodMapContents('');
                initializeNeighborhoodMap();
            }
        }
        ApartmentMaps.loadDynamicNeighborhoodMap = loadDynamicNeighborhoodMap;
        function initializeStaticNeighborhoodMap() {
            if (!ils.googleMapsApiLoaded) {
                ils.loadApartmentStaticMapScripts(() => {
                    var staticMapsTimeout = setTimeout(() => {
                        setMapsImage();
                        clearTimeout(staticMapsTimeout);
                    }, 150);
                });
            }
            else {
                setMapsImage();
            }
            function setMapsImage() {
                // Decode the encoded google maps path
                const decodedCoords = google.maps.geometry.encoding.decodePath(globalThis.neighborhoodArea.Coords);
                let coords = [];
                // We need to manually close the polygon shape so we get the coordinates of the first point and add a small decimal value to it so it's not the exact same
                const closingCoords = `${(decodedCoords[0].lat() + 0.0000001)},${(decodedCoords[0].lng() + 0.0000001)}`;
                // Iterate through the decoded coordinates and add them to the coords array we declared above
                for (let i = 0; i < decodedCoords.length; i++) {
                    let coord = `${decodedCoords[i].lat()},${decodedCoords[i].lng()}`;
                    coords.push(coord);
                }
                // Add the closing coordinates point to our array so we close the polygon shape
                coords.push(closingCoords);
                // Convert it to a string
                const coordsParam = coords.join('|');
                ////////////////////////////////////////
                // The commented out method below is a way to pass in the raw encoded path. The problem is that these paths are missing the closing coordinates so 
                // we have to manually add one
                //	const pathParam = encodeURIComponent(`weight:2|color:${globalThis.brandColorPrimary}|fillcolor:#fff|enc:${globalThis.neighborhoodArea.Coords}`);
                ////////////////////////////////////////
                // Create the "path" parameter we will use in the map img src URL. We need to URL encode it to make it valid for a URL
                const pathParam = encodeURIComponent(`weight:3|color:${brandColorPrimary.replace("#", "0x")}ff|fillcolor:0xfff|${coordsParam}`);
                // Create the map URL and the img tag
                const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?size=450x400&path=${pathParam}&key=${ils.googleMapsKey}`;
                const imageTag = `<img id="static-neighborhood-map" src="${mapUrl}" alt="Neighborhood map for ${ils.neighborhoodName}" style="${(globalThis.breakpoint() == 'mobile' ? 'width: 100%;' : 'width: 100%;')}" />`;
                // Insert the img tag using Knockout
                ils.viewModel.NeighborhoodMapContents(imageTag);
                // set our tracking variable to indicate this is loaded so we don't execute this logic again for this page
                ils.googleStaticNeighborhoodMapLoaded = true;
                // Send an event to google analytics so we can track our usage of static maps and where we use it
                ils.trackGoogleMapsEvent(ils.MapsGACategories.StaticMaps, 'load', 'CDP Neighborhood Map', 2);
                //ga('send', 'event', ils.MapsGACategories.StaticMaps, 'load', 'CDP Neighborhood Map', 2);
                var clickTimeout = setTimeout(() => {
                    $("#static-neighborhood-map").on('click', () => {
                        // Log a click event to Google Analytics
                        ils.trackGoogleMapsEvent(ils.MapsGACategories.StaticMaps, 'click', 'CDP Neighborhood Map', 2);
                        //ga('send', 'event', 'NeighborhoodMap', 'click', window.location.pathname);
                        //loadDynamicNeighborhoodMap();
                    });
                    clearTimeout(clickTimeout);
                }, 150);
            }
        }
        ApartmentMaps.initializeStaticNeighborhoodMap = initializeStaticNeighborhoodMap;
        function initializeNeighborhoodMap() {
            if (globalThis.neighborhoodMapLoaded)
                return;
            try {
                neighborhoodMap = new google.maps.Map(document.getElementById("neighborhood-map"), {
                    center: ils.mapCenter,
                    zoom: 13
                });
                var mapBounds = new google.maps.LatLngBounds();
                const decodedCoords = google.maps.geometry.encoding.decodePath(globalThis.neighborhoodArea.Coords);
                const polygon = new google.maps.Polygon({
                    paths: decodedCoords,
                    strokeColor: brandColorPrimary,
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#fff',
                    fillOpacity: 0.2
                });
                polygon.setMap(neighborhoodMap);
                for (let j = 0; j < decodedCoords.length; j++) {
                    mapBounds.extend(decodedCoords[j]);
                }
                AddPolygonEvents(polygon);
                infoBox = new InfoBox({
                    content: globalThis.neighborhoodArea.Name.toUpperCase(),
                    boxStyle: {
                        fontSize: "12pt",
                        fontFamily: 'Raleway-Bold',
                        textShadow: '0 0 2px #fff',
                        color: brandColorPrimary
                    },
                    disableAutoPan: true,
                    pixelOffset: new google.maps.Size(globalThis.neighborhoodArea.XOffset, globalThis.neighborhoodArea.YOffset),
                    position: mapBounds.getCenter(),
                    closeBoxURL: "",
                    enableEventPropagation: true
                });
                infoBox.open(neighborhoodMap);
                neighborhoodMap.fitBounds(mapBounds);
                google.maps.event.addListener(neighborhoodMap, 'zoom_changed', function () {
                    setTimeout(function () {
                        infoBox.setVisible(neighborhoodMap.getZoom() >= 10);
                    }, 200);
                });
                globalThis.neighborhoodMapLoaded = true;
                ils.trackGoogleMapsEvent(ils.MapsGACategories.DynamicMaps, 'load', 'CDP Neighborhood Map', 7);
                //ga('send', 'event', ils.MapsGACategories.DynamicMaps, 'load', 'CDP Neighborhood Map', 7);
            }
            catch (e) {
                console.error(e);
            }
        }
        ApartmentMaps.initializeNeighborhoodMap = initializeNeighborhoodMap;
        function createMarker(latlng) {
            var imageForRetina = new google.maps.MarkerImage(imageDomain + 'img/map-marker.png', null, null, null, new google.maps.Size(38, 61));
            var marker = new google.maps.Marker({ position: latlng, map: map, icon: imageForRetina });
            return marker;
        }
        ApartmentMaps.createMarker = createMarker;
        let counter = 0;
        function setMapZoom(maxZoomLevel) {
            if (map.getZoom() > maxZoomLevel)
                map.setZoom(maxZoomLevel);
            while (counter < 4 && map.getZoom() != maxZoomLevel) {
                counter++;
                let recursiveTimeout = setTimeout(() => {
                    setMapZoom(maxZoomLevel);
                    clearTimeout(recursiveTimeout);
                }, 1000);
            }
        }
        ApartmentMaps.setMapZoom = setMapZoom;
        function codeAddress(address, residence) {
            if (residence && globalThis.residenceLat != 0 && globalThis.residenceLong != 0) {
                var latlng = new google.maps.LatLng(globalThis.residenceLat, globalThis.residenceLong);
                markers[markers.length] = createMarker(latlng);
                bounds.extend(markers[markers.length - 1].position);
                map.fitBounds(bounds);
                let mapZoomTimeout = setTimeout(() => {
                    setMapZoom(17);
                    clearTimeout(mapZoomTimeout);
                }, 100);
            }
            else if (!residence && globalThis.officeLat != 0 && globalThis.officeLong != 0) {
                var latlng = new google.maps.LatLng(globalThis.officeLat, globalThis.officeLong);
                markers[markers.length] = createMarker(latlng);
                bounds.extend(markers[markers.length - 1].position);
                map.fitBounds(bounds);
                let mapZoomTimeout = setTimeout(() => {
                    setMapZoom(17);
                    clearTimeout(mapZoomTimeout);
                }, 100);
            }
            else if (address != "" && geocoder) {
                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        markers[markers.length] = createMarker(results[0].geometry.location);
                        bounds.extend(markers[markers.length - 1].position);
                        map.fitBounds(bounds);
                        let mapZoomTimeout = setTimeout(() => {
                            setMapZoom(17);
                            clearTimeout(mapZoomTimeout);
                        }, 100);
                    }
                });
            }
        }
        ApartmentMaps.codeAddress = codeAddress;
        function AddPolygonEvents(polygon) {
            google.maps.event.addListener(polygon, "mouseover", function () {
                this.setOptions({ fillOpacity: ".2" });
            });
            google.maps.event.addListener(polygon, "mouseout", function () {
                this.setOptions({ fillOpacity: ".5" });
            });
        }
        ApartmentMaps.AddPolygonEvents = AddPolygonEvents;
    })(ApartmentMaps = ils.ApartmentMaps || (ils.ApartmentMaps = {}));
})(ils || (ils = {}));
